<div class="_employee-desktop-page">

    <ng-container right *ngIf="action !== Action.CREATE">
        <page-header-component title="{{employee?.firstname}} {{employee?.lastname}}">
            <ng-container right *ifUserHasPermissions="[UserPermissions.WriteUsers]">
                <button type="button" class="_button _delete-button" (click)="deleteEmployee()">
                    <ion-icon src="./assets/icons/trash-outline.svg"></ion-icon>
                    <span>{{ 'EMPLOYEE.REMOVE' | translate}}</span>
                </button>
            </ng-container>
        </page-header-component>
    </ng-container>

    <ng-container right *ngIf="action === Action.CREATE">
        <page-header-component title="{{ 'EMPLOYEE.CREATE' | translate }}"></page-header-component>
    </ng-container>
    
    <div class="_employee-data-container">
        <div class="_container _employee-data" [ngClass]="{'_is-update': action !== Action.CREATE}">

            <form [formGroup]="employeeForm" *ngIf="employeeForm" [disable-form-if-not-permission]="[UserPermissions.WriteEmployees]">
                <p class="_title" [translate]="'EMPLOYEE.TITLE'"></p>
                <div class="_data-container">
                    <div class="_data _half">
                        <form-input label="{{ 'EMPLOYEE.FIRSTNAME' | translate }}" [formControl]="employeeForm.get('firstname') | cast"></form-input>
                    </div>
                    <div class="_data _half">
                        <form-input label="{{ 'EMPLOYEE.LASTNAME' | translate }}" [formControl]="employeeForm.get('lastname') | cast"></form-input>
                    </div>
                </div>
                
                <p class="_small-title _small-sub-title" [translate]="'EMPLOYEE.CONTACT_TITLE'"></p>
                <div class="_data-container">
                    <div class="_data _half">
                        <form-input label="{{ 'EMPLOYEE.EMAIL' | translate }}" [formControl]="employeeForm.get('email') | cast"></form-input>
                    </div>
                    <div class="_data _half">
                        <form-input label="{{ 'EMPLOYEE.PHONE' | translate }}" [formControl]="employeeForm.get('telephone') | cast"></form-input>
                    </div>
                </div>
        
                <p class="_small-title _small-sub-title" [translate]="'EMPLOYEE.EXTRA_TITLE'"></p>
                <div class="_data-container">
                    <div class="_data _half">
                        <form-input label="{{ 'EMPLOYEE.JOB_ROLE' | translate }}" [formControl]="employeeForm.get('jobRole') | cast"></form-input>
                    </div>
                    <div class="_data _half">
                        <form-select label="{{ 'EMPLOYEE.DIGIBANK_AGENCY' | translate }}" [formControl]="employeeForm.get('DigibankAgencyId') | cast" [items]="agencies" bindValue="id" bindLabel="name" [multiple]="false">
                        </form-select>
                    </div>
                    <div class="_data _half">
                        <form-select 
                            label="{{ 'EMPLOYEE.WANTS_BEEGO_COMMUNICATIE' | translate }}" 
                            [formControl]="employeeForm.get('receiveBeegoCommunication') | cast" 
                            [items]="wantsBeegoCommunicationOptions" 
                            bindValue="value" 
                            bindLabel="label" 
                            [multiple]="false"
                        >
                        </form-select>
                    </div>
                </div>
            </form>

            <ng-container *ngIf="action !== Action.CREATE">
                <div class="_buttons" *ifUserHasPermissions="[UserPermissions.WriteEmployees]">
                    <button type="button" class="_button _update" (click)="updateEmployee()">
                        <span>{{ 'EMPLOYEE.UPDATE' | translate}}</span>
                    </button>
                </div>
            </ng-container>
    
        </div>
    
        <div class="_container _user-data" *ngIf="action !== Action.CREATE && employee?.User">
            <div>
                <p class="_title" [translate]="'USERS.TITLE'"></p>
                <p class="_subtitle" [translate]="'USERS.SUBTITLE'"></p>

                <info-line icon="./assets/icons/user-outline.svg" align="top">
                    <p><b [translate]="'USERS.EMAIL'"></b></p>
                    <p>{{employee.email}}</p>
                </info-line>         
        
                <info-line icon="./assets/icons/user-outline.svg" align="top">
                    <p><b [translate]="'USERS.STATUS'"></b></p>
                    <p>
                        <span *ngIf="employee.User.isActive">{{'USERS.ACTIVE' | translate}}</span>
                        <span *ngIf="!employee.User.isActive && employee.User.isDisabled === false">{{'USERS.INACTIVE' | translate}}</span>
                        <span *ngIf="!employee.User.isActive && employee.User.isDisabled === true">{{'USERS.DEACTIVATED' | translate}}</span>
                    </p>
                </info-line>
        
                <info-line icon="./assets/icons/add-user-outline.svg" align="top">
                    <p><b [translate]="'USERS.CREATED_AT'"></b></p>
                    <p>{{employee.User.createdAt | date:"EEEE dd/MM/yyyy"}}</p>
                </info-line>
        
                <info-line icon="./assets/icons/created-by-outline.svg" align="top">
                    <p><b [translate]="'USERS.LAST_LOGIN'"></b></p>
                    <p>{{employee.User.lastAuthentication | date:"EEEE dd/MM/yyyy"}}</p>
                </info-line>
            </div>
    
            <div class="_buttons" *ifUserHasPermissions="[UserPermissions.WriteUsers]">
                <button *ngIf="employee.User.isActive === false && employee.User.isDisabled === false" type="button" class="_button _resend-button" (click)="resendInvite(employee.User.id)">
                    <ion-icon src="./assets/icons/reinvite-outline.svg"></ion-icon>
                    <span>{{ 'USERS.RE_INVITE' | translate}}</span>
                </button>
                <button *ngIf="employee.User.isActive === false && employee.User.isDisabled === true" type="button" class="_button _enable-button" (click)="enableUser(employee.User.id)">
                    <ion-icon src="./assets/icons/interval-outline.svg"></ion-icon>
                    <span>{{ 'USERS.ENABLED' | translate}}</span>
                </button>
                <button *ngIf="employee.User.isActive === true" type="button" class="_button _disable-button" (click)="disableUser(employee.User.id)">
                    <ion-icon src="./assets/icons/close-outline.svg"></ion-icon>
                    <span>{{ 'USERS.DISABLED' | translate}}</span>
                </button>
            </div>
        
        </div>
    
    </div>

    <ng-container *ifUserHasPermissions="[UserPermissions.WriteEmployees]">
        <permission-groups-component *ngIf="userForm" [form]="userForm" [type]="action === Action.CREATE ? 'create-user' : 'update-user'"></permission-groups-component>
    </ng-container>

    <ng-container *ngIf="action === Action.CREATE">
        <div class="_container _create-employee-container" *ifUserHasPermissions="[UserPermissions.WriteEmployees]">
            <div class="_buttons">
                <button type="button" class="_button _update" (click)="createEmployee()">
                    <span>{{ 'EMPLOYEE.CREATE' | translate}}</span>
                </button>
            </div>
        </div>
    </ng-container>

</div>